<div class="modal-content">
  <div class="modal-header bg-danger text-white">
    <h4>{{ dialogTitle }}</h4>
  </div>
  <div class="modal-body">
    <p>
      {{ dialogMessage }}
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-sm" (click)="close()">
      Close
    </button>
  </div>
</div>
